module.exports = __webpack_public_path__ + "img/Master-6.c6a15e67.png";